import defaultTheme from './defaultTheme';
const hsnTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#0075cb', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#0075cb', background: '#0075cb' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#0075cb' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#0075cb', border: '#0075cb', background: '#0075cb' }), field: {
        focus: '#0075cb',
        label: '#0075cb',
        icon: '#0075cb',
    } });
export default hsnTheme;
